module.exports = __webpack_public_path__ + "static/media/super_topup_myway.0284fa1f.svg";